document.addEventListener('DOMContentLoaded', function () {
	const jQuery = window.jQuery || {};
	let slickContainer = jQuery('.curated-list');
	const loadTiledSlider = () => {
		if( typeof slickContainer.slick === 'function' ) {
			slickContainer.slick({
				// use .not( 'slick-initialized' ) to avoid console error on page resize
				// slick uses max-width for responsive sizes so we need a second crazy large breakpoint
				slidesToShow: 1,
				responsive: [
					{
						breakpoint: 9999,
						settings: 'unslick',
					},
					{
						breakpoint: 767,
						settings: {
							variableWidth: true,
							dots: true,
							centerMode: false,
							arrows: false,
							infinite: false,
						},
					},
				],
			});
		}
	};
	loadTiledSlider();
	window.addEventListener('resize', function () {
		// watch window resizing to switch layout of module
		// this will enhance the slick responsive settings
		// using throttle to mitigate performance issues with resize
		if (
			window.hmUtils &&
			window.hmUtils.throttle(window.screen.availWidth < 768, 800)
		) {
			loadTiledSlider();
		} else {
			typeof slickContainer.slick === 'function' && slickContainer.slick('unslick');
		}
	});
});
